import type { ComponentType } from 'react';
import ErrorOutlineIcon from '@mildang/icons/react/error-outline';
import WarningIcon from '@mildang/icons/react/warning-fill';
import OpenInNewIcon from '@mildang/icons/react/open-in-new';
import InfoOutline from '@mildang/icons/react/info-outline';
import CheckCircleOutline from '@mildang/icons/react/check-circle-outline';

export type HelpTextVariantLiteral = 'info' | 'error' | 'warning' | 'link' | 'success';

export const HELP_TEXT_ICONS: Record<HelpTextVariantLiteral, ComponentType<{ className?: string }>> = {
  info: InfoOutline,
  error: ErrorOutlineIcon,
  warning: WarningIcon,
  link: OpenInNewIcon,
  success: CheckCircleOutline,
};
